const changelogListElips = `
    <ul> 
      <li> Text 
        <ul>
          <li><code>text-body-highlight </code></li>
          <li><code>text-body-quaternary </code></li>
          <li> <code>text-body-hover </code> </li>
          <li> <code>text-body-secondary-hover </code></li>
          <li><code>text-body-tertiary-hover </code></li>
          <li><code>text-body-quaternary-hover</code></li>
          <li><code>text-body-highlight-hover </code></li>
          <li><code>text-{themeColor}-light </code></li>
          <li><code>text-{themeColor}-lighter </code></li>
          <li><code>text-{themeColor}-dark </code></li>
          <li><code>text-{themeColor}-darker </code></li>
        </ul>
      </li>
      <li> dark__bg-opacity-{0|25|50|75|85|100} </li>
      <li> Background 
        <ul>
          <li>
            <code>bg-body-emphasis</code>
          </li>
          <li>
            <code>bg-body-quaternary</code>
          </li>
          <li>
            <code>bg-body-highlight</code>
          </li>
          <li>
            <code>bg-body-hover</code>
          </li>
          <li>
            <code>bg-body-secondary-color</code>
          </li>
          <li>
            <code>bg-body-tertiary-color</code>
          </li>
          <li>
            <code>bg-body-quaternary-color</code>
          </li>
          <li>
            <code>bg-{themeColor}-light</code>
          </li>
          <li>
            <code>bg-{themeColor}-lighter</code>
          </li>
          <li>
            <code>bg-{themeColor}-dark</code>
          </li>
          <li>
            <code>bg-{themeColor}-darker</code>
          </li>

        </ul>
      <li> Border 
        <ul>
          <li><code>border-translucent</code></li>
          <li><code>border-{themeColor}-light</code></li>
          <li><code>border-{themeColor}-dark</code></li>
        </ul>
      </li>
      <li> Link 
        <ul>
          <li><code>link-body</code></li>
          <li><code>link-body-secondary</code></li>
          <li><code>link-body-highlight</code></li>
          <li><code>link-body-quaternary</code></li>
          <li><code>link-body-tertiary</code></li>

        </ul>
      </li>
      <li> Font Size 
        <ul>
          <li>Replaced <code>.fs--3</code> with <code>.fs-11</code></li>
          <li>Replaced <code>.fs--2</code> with <code>.fs-10</code></li>
          <li>Replaced <code>.fs--1</code> with <code>.fs-9</code></li>
          <li>Replaced <code>.fs-0</code> with <code>.fs-8</code></li>
          <li>Replaced <code>.fs-1</code> with <code>.fs-</code></li>
          <li>Replaced <code>.fs-2</code> with <code>.fs-6</code></li>
          <li>Replaced <code>.fs-3</code> with <code>.fs-5</code></li>
          <li>Replaced <code>.fs-4</code> with <code>.fs-4</code></li>
          <li>Replaced <code>.fs-5</code> with <code>.fs-3</code></li>
          <li>Replaced <code>.fs-6</code> with <code>.fs-2</code></li>
          <li>Replaced <code>.fs-7</code> with <code>.fs-1</code></li>
        </ul>
      </li>
    </ul>
    `;

export default changelogListElips;
